import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { Globals } from '../_globals';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { CategoryService } from 'app/_services/category.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-setup',
    templateUrl: './setup.component.html',
    styleUrls: ['./setup.component.css'],
})
export class SetupComponent implements OnInit {
    role: any;
    routeRole: any;
    cookieStore: any;
    templates = [];

    categoryTemplateForm: FormGroup;

    constructor(
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public confirmationService: ConfirmationService,
        public _categoryService: CategoryService,
        public fb: FormBuilder
    ) {
        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            // console.log('this.cookieStore', this.cookieStore);
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }

        this.categoryTemplateForm = fb.group({
            categoryTemplate: new FormControl('', [Validators.required]),
        });
        this.getTemplates();
    }

    ngOnInit() { }

    getTemplates() {
        this._categoryService.getCategoryTemplates().subscribe(
            (data: any) => {
                //  console.log('templates', data.categoryTemplates);
                this.templates = data.categoryTemplates;
            },
            (error) => {
                console.log('error getting templates', error);
            }
        );
    }

    categoryTemplateFormSubmit() {
        const values = this.categoryTemplateForm.value;
        const templateId = values.categoryTemplate.name;
        const storeId = this.cookieStore.id;
        // console.log('templateId', templateId);
        // console.log('storeId', storeId);

        this.confirmationService.confirm({
            message:
                'Are you sure you wish to apply this template to your store? It will replace all existing categories.',
            accept: () => {
                this._categoryService.applyTemplate(templateId, storeId).subscribe(
                    (data: any) => {
                        alert('Chosen template has been applied');
                        console.log('template applied', data);
                    },
                    (error) => {
                        alert('Template could not be applied');
                        console.log('error applying template', error);
                    }
                );
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/setup/setup.component.ts